// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3NTx9","itemTitle":"ClientEmergencyInfo_itemTitle__3QGMG","itemText":"ClientEmergencyInfo_itemText__2GFuS"};